"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoPopUp = void 0;
const common_1 = require("@app/components/common");
const react_1 = __importDefault(require("react"));
const InfoPopUp_elements_1 = require("@app/routes/Landing/components/MainLanding/components/InfoPopUp/InfoPopUp.elements");
const InfoPopUp = ({ children, onClose }) => {
    return (react_1.default.createElement(common_1.PopUp, { title: "", onClose: onClose },
        react_1.default.createElement(InfoPopUp_elements_1.InfoPopUpContent, null,
            react_1.default.createElement("h1", null, children))));
};
exports.InfoPopUp = InfoPopUp;
